import { css } from "lit";

export const iconBadgeStyles = css`
  .badge {
    padding: var(--badge-padding, 4px 8px 4px 6px);
  }

  .badge.small {
    --badge-padding: 4px 8px 4px 6px;
  }

  ::slotted([slot="icon"]) {
    flex-shrink: 0;
    color: var(--badge-icon-color, inherit);
  }
`;
